import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest, getUserDetails } from "../../services/apiRequest";
import { requestType } from "../../services/requests";
import { addToLoader } from "../loader/loaderSlice";

const initialState = {
    data: [],
    loading: false,
    error: false,
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const getItineraryPorts = createAsyncThunk(
    "itineraryPorts/get",
    async ({region_uid, language = window.currentLanguage.toString()}, thunkAPI) => {
        thunkAPI.dispatch(addToLoader(true));
        const response = await apiRequest({
            payload: {
                data: {
                    user_uid: getUserDetails().user_details.uid,
                    region_uid: region_uid.toString(),
                    language: language
                },
            },
            requestType: requestType.getItineraryPorts,
        });
        thunkAPI.dispatch(addToLoader(false));
        return response.data.data.itinerary_ports;
    }
);

export const itineraryPortsSlice = createSlice({
    name: "itineraryPorts",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        addToItineraryPortsData: (state, action) => {
            state.data = action.payload;
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(getItineraryPorts.pending, (state) => {
                state.loading = true;
            })
            .addCase(getItineraryPorts.fulfilled, (state, { payload }) => {
                // When the API call is successful and we get some data,the data becomes the `fulfilled` action payload
                state.loading = false;
                state.data = payload;
            })
            .addCase(getItineraryPorts.rejected, (state) => {
                state.loading = false;
                state.error = true;
            });
    },
});

export const { addToItineraryPortsData } = itineraryPortsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.itineraryPorts.value)`
export const selectItineraryPorts = (state) => state.itineraryPorts;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.

export default itineraryPortsSlice.reducer;
